export default __webpack_public_path__ + "assets/images/1a830116faa85328ac685cfacc754e1c.png";